import React, { Component } from 'react'
import { checkBeta } from '../../utils/beta'
import { connect } from 'react-redux'
import { logout as actionLogout } from '../../redux-flow/actions/login'

class InsideMenu extends Component {

    componentDidMount() {
        const { nome, logout } = this.props
        if(nome == undefined || nome == '' || nome == null) {
            logout()
        }
    }

    render() {
        var { nome } = this.props
        nome = nome.split(' ')
        return  ( 
                    <div>
                        <div className="d-flex align-items-end justify-content-between tabTitleWrapper">
                            <h4 className="pageTitle tx-gray" style={{fontWeight: 'bold'}}>Olá, {nome[0]}</h4>
                        </div>
                        {/* <hr />     */}
                    </div>          
        )  
    } 
}

const mapStateToProps = state => ({
    nome: state.login.nome,
})
        
const mapDispatchToProps = dispatch => ({
    logout: e => {
        // e.preventDefault()
        dispatch(actionLogout())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(InsideMenu)
  